import Vue from 'vue'
import Login from './LoginMain.vue'

const loginPlugins = Vue.extend(Login)
loginPlugins.install = function () {
  let instance = new loginPlugins({
    el: document.createElement('div')
  }).$mount()
  document.body.appendChild(instance.$el); //将构造器实例挂载对象插入body里面
  Vue.nextTick(() => {
    instance.init();
    // instance.isShow = true  //传入字段
  })
}

export default loginPlugins;